import React from "react";

import { useBundleBuilder } from "../BundleBuilderContext";
import { BundlePreviewItem } from "./BundlePreviewItem";

export const BundlePreview = () => {
  const { bundleCartItems, updateItemQuantity } = useBundleBuilder();

  return (
    <div
      style={{
        padding: "16px 0",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        maxHeight: "300px",
        overflowY: "auto",
      }}
    >
      {bundleCartItems.map((item) => (
        <BundlePreviewItem
          key={`preview-item-${item.variantId}`}
          item={item}
          onUpdateQuantity={(newQty) => {
            return updateItemQuantity(item.variantId, newQty);
          }}
        />
      ))}
    </div>
  );
};
